import React from "react";
import PropTypes from "prop-types";

export const FilledPersonRectangleIcon = ({
  fillColor = "currentColor",
} = {}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.4857 0.714355H18.9143C20.3344 0.714355 21.4857 1.86562 21.4857 3.28578V18.7144C21.4857 20.1345 20.3344 21.2858 18.9143 21.2858H3.4857C2.06554 21.2858 0.914276 20.1345 0.914276 18.7144V3.28578C0.914276 1.86562 2.06554 0.714355 3.4857 0.714355ZM11.0736 9.89033C12.4241 9.89033 13.5188 8.79561 13.5188 7.44519C13.5188 6.09478 12.4241 5.00006 11.0736 5.00006C9.72324 5.00006 8.62851 6.09478 8.62851 7.44519C8.62851 8.79561 9.72324 9.89033 11.0736 9.89033ZM16.3428 16.1429C16.234 14.919 15.6343 13.7854 14.6725 12.9859C13.7107 12.1864 12.4638 11.785 11.1999 11.8679C9.9361 11.785 8.68918 12.1864 7.7274 12.9859C6.76563 13.7854 6.16585 14.919 6.05708 16.1429H16.3428Z"
      fill={fillColor}
    />
  </svg>
);

FilledPersonRectangleIcon.propTypes = {
  fillColor: PropTypes.string,
};
